export default __webpack_public_path__ + "static/media/logo-small.8afed040.svg";